
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const SearchIcon2 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 23 23" fill="none" >
            <path d="M9.35059 0.75C14.1033 0.750182 17.9502 4.58547 17.9502 9.30957C17.9502 14.0336 14.1033 17.869 9.35059 17.8691C4.59773 17.8691 0.750025 14.0338 0.75 9.30957C0.75 4.58536 4.59771 0.75 9.35059 0.75Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="0.75" y1="-0.75" x2="9.72043" y2="-0.75" transform="matrix(0.743663 0.668555 -0.679688 0.733501 14.2136 16)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
  )
}
